import axios, { AxiosRequestConfig } from 'axios'

import Network from '..'
import { clearAuthStorage, setSessionExpiredFlag } from '@/utils/storage'

// Timeout padrão: 2 minutos para uploads grandes (5MB+) que levam 30-60s de processamento backend
// (parse CSV + lookup CRM + validações + bulk insert). Pode ser sobrescrito por request.
const DEFAULT_TIMEOUT_MS = 120000

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: DEFAULT_TIMEOUT_MS
})

api.interceptors.request.use((config: AxiosRequestConfig) => {
  const token = Network.auth.getLocalToken()
  const companies = Network.company.getLocalTokenCompanyList()

  if (token && config.headers) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${token}`
    config.headers.company_ids = companies
  }

  return config
})

let isRedirectingOn401 = false

api.interceptors.response.use(
  (response) => response,
  (e) => {
    const isUnauthorized = e.response?.status === 401 || e.response?.data?.statusCode === 401

    if (isUnauthorized && !isRedirectingOn401) {
      isRedirectingOn401 = true
      clearAuthStorage()
      // Depois do clear (não é removida por ele, mas garante a ordem) e antes
      // do redirect: a tela de login consome a flag e avisa "sessão expirada".
      setSessionExpiredFlag()

      window.location.href = '/'
    }

    return Promise.reject(e)
  }
)

export default api
